import React, { useState } from "react";

import Box from "@material-ui/core/Box";
import Rating from "@material-ui/core/Rating";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import { Button } from "@material-ui/core";
import { PostAdd } from "@material-ui/icons";

import { useDispatch } from "react-redux";
import { postReview } from "../../store/dishes/actions";

export default function ReviewForm(props) {
  const dispatch = useDispatch();
  const [overall, setOverall] = useState();
  const [size, setSize] = useState();
  const [benefit, setBenefit] = useState();
  const [presentation, setPresentation] = useState();
  const [taste, setTaste] = useState();

  function sendReview(event) {
    event.preventDefault();
    const id = props.selectedId;

    dispatch(postReview(overall, size, presentation, taste, benefit, id));
  }

  return (
    <Box
      sx={{
        "& > legend": { mt: 2 },
      }}
    >
      <Typography component="legend">Overall</Typography>
      <Rating
        name="simple-controlled"
        required
        value={overall}
        onChange={(event, newValue) => {
          setOverall(parseInt(newValue));
        }}
      />
      <Typography component="legend">Cost-benefit</Typography>
      <Rating
        name="simple-controlled"
        value={benefit}
        onChange={(event, newValue) => {
          setBenefit(parseInt(newValue));
        }}
      />
      <Typography component="legend">Taste</Typography>
      <Rating
        name="simple-controlled"
        value={taste}
        onChange={(event, newValue) => {
          setTaste(parseInt(newValue));
        }}
      />
      <Typography component="legend">Presentation</Typography>
      <Rating
        name="simple-controlled"
        value={presentation}
        onChange={(event, newValue) => {
          setPresentation(parseInt(newValue));
        }}
      />
      <p></p>
      <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
        <InputLabel id="demo-simple-select-standard-label">Size</InputLabel>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={size}
          onChange={(event) => {
            setSize(parseInt(event.target.value));
          }}
          label="size"
        >
          <MenuItem value={1}>Tiny</MenuItem>
          <MenuItem value={2}>Small</MenuItem>
          <MenuItem value={3}>Medium</MenuItem>
          <MenuItem value={4}>Big</MenuItem>
          <MenuItem value={5}>Huge</MenuItem>
        </Select>
      </FormControl>
      <p></p>
      <p></p>
      <Button variant="outlined" startIcon={<PostAdd />} onClick={sendReview}>
        Send
      </Button>
    </Box>
  );
}
